import { render, staticRenderFns } from "./ColorSection.vue?vue&type=template&id=d2290620&scoped=true&"
import script from "./ColorSection.vue?vue&type=script&lang=ts&"
export * from "./ColorSection.vue?vue&type=script&lang=ts&"
import style0 from "./ColorSection.vue?vue&type=style&index=0&id=d2290620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2290620",
  null
  
)

export default component.exports